import Loading from "@components/common/Loading";
import { QUERY_KEY } from "@config/queryKeys";
import { getBanner } from "@services/settings";
import React, { Suspense } from "react";
import { useQuery } from "react-query";
import { Outlet } from "react-router-dom";
import MyJobBar from "./MyJobBar";
import MyJobSlideBanner from "./MyJobSlideBanner";

const LayoutJobs = () => {
  const { data: banners } = useQuery({
    queryFn: () => getBanner("jobapply"),
    queryKey: QUERY_KEY.BANNER_JOBS,
  });

  return (
    <div className="jvs-p-t jvs-p-b65">
      <MyJobSlideBanner banners={banners?.data?.data} />
      <MyJobBar />
      <Suspense fallback={<Loading loading />}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default LayoutJobs;
